// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.button-group {
    display: flex;
    justify-content: center; /* Center aligns the buttons horizontally */
    padding: 10px; /* Adds padding around the buttons */
    gap: 10px; /* Space between the two buttons */
    width: 100%;
}

.button-group input[type="range"] {
  width: 50%;
}

.chart-container {
  width: 100%;
  max-width: 90%;
  margin: 10px auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  box-sizing: border-box;
}

.chart-wrapper {
  width: 100%;
  position: relative;
}

.pnl-chart {
  height: 250px;
  width: 100%;
}

.tas-chart {
  height: 200px;
  width: 100%;
}

.trade-chart {
  height: 150px;
  width: 100%;
}
  
.price-chart {
  height: 300px;
  width: 100%;
}

.vix-chart {
  height: 300px;
  width: 100%;
}

.volume-chart {
  height: 300px;
  width: 100%
}

.macd-chart {
  height: 300px;
  width: 100%
}

.rsi-chart {
  height: 300px;
  width: 100%;
}

/* canvas {
  margin-left: -10px;
}

.chart-wrapper canvas {
  border-left: 1px solid #ddd;
} */

.slider-container {
  width: 100%;
  margin: 20px 0;
}

.horizontal-slider {
  width: 100%;
  height: 25px;
}
  
.thumb {
    height: 25px;
    width: 25px;
    background-color: #007bff;
    border-radius: 50%;
    cursor: pointer;
    top: 0;
    position: relative;
  }
  
.track {
    top: 0;
    bottom: 0;
    background: #ddd;
    border-radius: 999px;
  }`, "",{"version":3,"sources":["webpack://./src/dashboard/components/InstrumentCharts.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,uBAAuB,EAAE,2CAA2C;IACpE,aAAa,EAAE,oCAAoC;IACnD,SAAS,EAAE,kCAAkC;IAC7C,WAAW;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;;;;;GAMG;;AAEH;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,kBAAkB;EACpB;;AAEF;IACI,MAAM;IACN,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB","sourcesContent":["\n.button-group {\n    display: flex;\n    justify-content: center; /* Center aligns the buttons horizontally */\n    padding: 10px; /* Adds padding around the buttons */\n    gap: 10px; /* Space between the two buttons */\n    width: 100%;\n}\n\n.button-group input[type=\"range\"] {\n  width: 50%;\n}\n\n.chart-container {\n  width: 100%;\n  max-width: 90%;\n  margin: 10px auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.chart-wrapper {\n  width: 100%;\n  position: relative;\n}\n\n.pnl-chart {\n  height: 250px;\n  width: 100%;\n}\n\n.tas-chart {\n  height: 200px;\n  width: 100%;\n}\n\n.trade-chart {\n  height: 150px;\n  width: 100%;\n}\n  \n.price-chart {\n  height: 300px;\n  width: 100%;\n}\n\n.vix-chart {\n  height: 300px;\n  width: 100%;\n}\n\n.volume-chart {\n  height: 300px;\n  width: 100%\n}\n\n.macd-chart {\n  height: 300px;\n  width: 100%\n}\n\n.rsi-chart {\n  height: 300px;\n  width: 100%;\n}\n\n/* canvas {\n  margin-left: -10px;\n}\n\n.chart-wrapper canvas {\n  border-left: 1px solid #ddd;\n} */\n\n.slider-container {\n  width: 100%;\n  margin: 20px 0;\n}\n\n.horizontal-slider {\n  width: 100%;\n  height: 25px;\n}\n  \n.thumb {\n    height: 25px;\n    width: 25px;\n    background-color: #007bff;\n    border-radius: 50%;\n    cursor: pointer;\n    top: 0;\n    position: relative;\n  }\n  \n.track {\n    top: 0;\n    bottom: 0;\n    background: #ddd;\n    border-radius: 999px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
